import React from 'react';
import Hero from './components/IQAC/student-projects-reports/Hero';
import Main from './components/IQAC/student-projects-reports/Main';

const IqacStudentProjectsReports = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacStudentProjectsReports;